import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiscountsComponent } from './discounts.component';
import { NgxLoadingModule } from 'ngx-loading';
import { UIModule } from '@common/UI/UI.module';
import { CoreModule } from '@core/core.module';
import { DirectivesModule } from '@common/directives/directives.module';
import { ViewerComponent } from './viewer/viewer.component';
import { InvoicesModule } from '@routes/invoices/invoices.module';



@NgModule({
  declarations: [
    DiscountsComponent,
    ViewerComponent
  ],
  imports: [
    CommonModule,
    InvoicesModule,
    CoreModule,
    DirectivesModule,
    UIModule,
    NgxLoadingModule
  ],
  exports: [
    DiscountsComponent
  ]
})
export class DiscountsModule { }
